import { render, staticRenderFns } from "./TraxTrainingProgramCrudSearch.vue?vue&type=template&id=14582009"
import script from "./TraxTrainingProgramCrudSearch.vue?vue&type=script&lang=js"
export * from "./TraxTrainingProgramCrudSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports